{
  "$id": "http://softball.app/schemas/plate-appearance",
  "title": "Plate Appearance",
  "type": "object",
  "description": "Information about an individual plate appearance",
  "required": ["id", "playerId", "result", "location"],
  "properties": {
    "id": {
      "type": "string",
      "tsType": "PlateAppearanceId",
      "description": "Random 64-bit unique identifier for this plate appearance"
    },
    "playerId": {
      "type": "string",
      "tsType": "PlayerId",
      "description": "The id of the player who is the batter during the plate appearance"
    },
    "result": {
      "type": ["string", "null"],
      "description": "The outcome of the plate appearance for the batter (e.g. BB, E, 1B, etc.)"
    },
    "runners": {
      "type": "object",
      "description": "Location of runners after the conclusion of the plate appearance",
      "properties": {
        "1B": {
          "type": "string"
        },
        "2B": {
          "type": "string"
        },
        "3B": {
          "type": "string"
        },
        "scored": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "out": {
          "type": "array",
          "items": {
            "type": "string"
          },
          "maxItems": 3
        }
      },
      "additionalProperties": false
    },
    "location": {
      "type": "object",
      "description": "Where the ball was hit",
      "required": ["x", "y"],
      "properties": {
        "x": {
          "type": ["integer", "null"],
          "description": "X coordinate of where the ball was fielded (or where the ball ended at the end of the plate appearance if not fielded). Expressed as 32767ths of the field image from the left"
        },
        "y": {
          "type": ["integer", "null"],
          "description": "Y coordinate of where the ball was fielded (or where the ball ended at the end of the plate appearance if not fielded). Expressed as 32767ths of the field image from the top"
        }
      }
    }
  }
}
